// extracted by mini-css-extract-plugin
export default {"auth__overlay":"styles_auth__overlay__ZVsI0","fadeIn":"styles_fadeIn__nngwQ","auth__Container":"styles_auth__Container__a8qc1"};